import { IconStore } from '@/app/components/icons/business-payments/icon-store';
import { IconBuild } from '@/app/components/icons/common-actions/icon-build';
import { IconColors } from '@/app/components/icons/text-formatting/icon-colors';
import { IconCar } from '@/app/components/icons/transportation/icon-car';
import { IconCalendarMonth } from '@/app/components/icons/ui-actions/icon-calendar-month';
import { createIconMapping } from '@/app/utils/createIconMapping';

export const ICON_DEALER_TYPE_MAP = createIconMapping({
  IconCar: <IconCar />,
  IconStore: <IconStore />,
  IconBuild: <IconBuild />,
  IconColors: <IconColors />,
  IconCalendarMonth: <IconCalendarMonth />,
});
